module.exports = __webpack_public_path__ + "img/admin_adv_15.49e518a3.png";